<template>
  <span>
    <a href="#" @click.prevent="$bvModal.show(modalId)"><i class="fa fa-lg fa-search mr-2"></i></a>
    <b-modal
      :id="modalId"
      size="xl"
      title="Programación de producción"
      @show="onShow"
      body-class="p-0"
      ok-title="Descargar"
      @ok="descargarPDF"
    >
      <div class="text-center">
        <b-spinner v-if="loading"></b-spinner>
      </div>
      <div v-if="ready" id="printArea">
        <h1>Producción {{ id }}</h1>
        <h4>
          Fecha de producción:
          {{ data.date }}
        </h4>
        <h4>Turno: {{ shifts[data.config.shift] }}</h4>
        <h4>Línea: {{ lines[data.config.line] }}</h4>
        <template v-for="op in data.config.defectFilters">
          <h5 class="font-italic" v-if="op.defects.length > 0" :key="op.op">
            -> Para OP #{{ op.op }} use {{ filtersToRepr(op.defects) }}
          </h5>
        </template>
        <b-table-simple hover small caption-top responsive>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <b-thead head-variant="dark">
            <b-tr>
              <b-th colspan="9">Materia prima</b-th>
              <template v-for="op in data.config.ops">
                <b-th colspan="3" class="text-center">
                  OP #{{ op.id }} <br />
                  {{ op.container.name }} <br />
                  {{ op.container.sku }}</b-th
                >
              </template>
              <!-- <b-th colspan="2">Totales</b-th> -->
            </b-tr>
            <b-tr>
              <b-th>Orden</b-th>
              <b-th>Pallet</b-th>
              <b-th>Condicion</b-th>
              <b-th>Lote</b-th>
              <b-th>Productor</b-th>
              <b-th>Variedad</b-th>
              <b-th>F. Recepcion</b-th>
              <b-th>QC</b-th>
              <b-th>Kg Netos</b-th>
              <template v-for="op in data.config.ops">
                <b-th>P Kg</b-th>
                <b-th>P Kg Dh</b-th>
                <b-th>P Cajas</b-th>
              </template>
              <!-- <b-th>Cajas</b-th>
              <b-th>Total</b-th> -->
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, itemIdx) in tableData" :key="itemIdx">
              <b-th class="text-left">{{ itemIdx + 1 }} <i class="fa fa-check" v-show="!item.consumed"></i> </b-th>
              <b-th>{{ item.pallet_number }}</b-th>
              <b-th>{{ item.condition }}</b-th>
              <b-th>{{ item.lot_number }}</b-th>
              <b-th>{{ item.origin_name }}</b-th>
              <b-th>{{ item.variety_name }}</b-th>
              <b-th>{{ item.creation_date }}</b-th>
              <b-th><i :class="`fa fa-lg fa-circle text-${item.color}`"></i></b-th>
              <b-th>{{ item.net_kilograms }}</b-th>
              <template v-for="op in data.config.ops">
                <b-td class="border-left" variant="secondary" :key="`pkg-${op.id}`">{{
                  item[op.id].potential_kg
                }}</b-td>
                <b-td variant="secondary" :key="`pkgdh-${op.id}`">{{ item[op.id].potential_kg_after_dh }}</b-td>
                <b-td class="border-right" variant="secondary" :key="`boxes-${op.id}`">{{
                  item[op.id].potential_boxes
                }}</b-td>
              </template>
              <!-- <b-th></b-th>
              <b-th></b-th> -->
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td :colspan="totalCols" variant="secondary" class="text-right">
                Total Pallets: <b>{{ tableData.length }}</b> <br />
                <template v-for="op in data.ops">
                  <pre>
                    {{ op }}
                  </pre>
                </template>
                Kgs volteados esperados: <b>{{ totalNet }}</b> <br />
                Kgs exportables esperados: <b>{{ totalExp }}</b> <br />
                Porcentaje de exportación esperado: <b>{{ expPercent }} %</b> <br />
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
      </div>
    </b-modal>
  </span>
</template>

<script>
import html2pdf from "html2pdf.js";
import qimaDict from "../../../lang/QIMA";
export default {
  name: "ProductionPlanReport",
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    modalId() {
      return `modal-pp-report-${this.id}`;
    },
    totalCols() {
      return 9 + this.data.config.ops.length * 3;
    },
    totalNet() {
      let total = this.tableData.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0);
      return total.toFixed(2);
    },
    totalExp() {
      let total = 0;
      this.tableData.forEach((item) => {
        this.data.config.ops.forEach((op) => {
          if (item[op.id] && item[op.id].potential_kg) {
            total += parseFloat(item[op.id].potential_kg);
          }
        });
      });
      return total.toFixed(2);
    },
    expPercent() {
      return (this.totalExp / this.totalNet).toFixed(3) * 100;
    }
  },
  data() {
    return {
      loading: true,
      ready: false,
      data: [],
      tableData: [],
      columns: [
        { key: "index", label: "Orden" },
        { key: "id", label: "ID" },
        { key: "pallet_number", label: "Pallet" }
      ],
      // Harcodeado desde base de datos shifts y lines
      shifts: {
        10: "Tarde",
        11: "Feriado",
        9: "Noche",
        12: "Día"
      },
      lines: {
        36: "S-0",
        37: "S-1",
        74: "Camara",
        89: "sala1",
        90: "sala1",
        91: "Sala 1",
        93: "Sala 1",
        95: "CAMARA",
        35: "Linea-1",
        49: "Linea-3",
        100: "Camara",
        103: "camara",
        48: "2 GP"
      }
    };
  },
  methods: {
    getQimaMeaning(key) {
      return qimaDict[key] || key;
    },
    filtersToRepr(filtersArray) {
      let newFilters = [];
      for (let filter of filtersArray) {
        newFilters.push(this.getQimaMeaning(filter));
      }
      return newFilters.join(", ");
    },
    onShow() {
      this.tableData = [];
      this.data = [];
      this.getData().then(() => {
        console.log(this.data.date);
      });
    },
    async getData() {
      this.loading = true;
      try {
        const res = await this.$axios.get(`/api/v1/production_plan/${this.id}/`);
        this.data = res.data;
        const ops = this.data.config.ops;
        const items = ops[0]["detailed_selected_items"];
        const palletList = items.map((item) => item.id).join(",");
        const res2 = await this.$axios.get(`/api/v1/production_plan/get_consumed_pallets/?pallet_list=${palletList}`);
        for (let item of items) {
          const res2Item = res2.data.find((i) => i.id === item.id);
          item["consumed"] = res2Item.status_content;
          this.tableData.push(item);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
        this.ready = true;
      }
    },
    descargarPDF() {
      const element = document.getElementById("printArea").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "png" },
        filename: `Produccion-${this.id}.pdf`,
        html2canvas: { dpi: 96, scale: 1.5 },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped>
/* Print-specific Styles */
@media print {
  body {
    background-color: #fff;
  }

  .content {
    width: 100%;
    color: #000;
    margin: 0;
    padding: 0;
  }

  /* Hide elements not needed in print */
  .no-print {
    display: none;
  }
}
</style>
